<template>
  <div id="center">
    <div class="up">
      <div
        class="bg-color-black item"
        v-for="item in titleItem"
        :key="item.title"
      >
        <p class="ml-3 colorBlue fw-b fs-xl">{{ item.title }}</p>
        <div>
          <dv-digital-flop
            class="dv-dig-flop ml-1 mt-2 pl-3"
            :config="item.number"
          />
        </div>
      </div>
    </div>
    <div class="down">
      <div class="ranking bg-color-black">
        <span>
          <icon name="chart-pie" class="text-icon"></icon>
        </span>
        <span class="fs-xl text mx-2 mb-1 pl-3">各省市残疾人就业基地数目</span>
        <dv-scroll-ranking-board
          class="dv-scr-rank-board mt-1"
          :config="ranking"
        />
      </div>
      <!-- <div class="percent"> -->
      <!-- <div class="item bg-color-black">
          <span>今日任务通过率</span>
          <CenterChart
            :id="rate[0].id"
            :tips="rate[0].tips"
            :colorObj="rate[0].colorData"
          />
        </div>
        <div class="item bg-color-black">
          <span>今日任务达标率</span>
          <CenterChart
            :id="rate[1].id"
            :tips="rate[1].tips"
            :colorObj="rate[1].colorData"
          />
        </div> -->

      <!-- </div> -->
    </div>
  </div>
</template>

<script>
// import CenterChart from '@/components/echart/center/centerChartRate'
const formatter = (number) => {
  const numbers = number
    .toString()
    .split("")
    .reverse()
  const segs = []

  while (numbers.length) segs.push(numbers.splice(0, 3).join(""))

  return segs
    .join(",")
    .split("")
    .reverse()
    .join("")
}
export default {
  data() {
    return {
      titleItem: [
        {
          title: "赋能培训基地",
          number: {
            number: [310],
            toFixed: 0,
            textAlign: "left",
            content: "{nt}个",
            style: {
              fontSize: 26,
            },
            formatter,
          },
        },
        {
          title: "培训人数",
          number: {
            number: [6429],
            toFixed: 0,
            textAlign: "left",
            content: "{nt}人",
            style: {
              fontSize: 26,
            },
            formatter,
          },
        },
        {
          title: "培训合规率",
          number: {
            number: [97.23],
            toFixed: 2,
            textAlign: "left",
            content: "{nt}%",
            style: {
              fontSize: 26,
            },
          },
        },
        {
          title: "就业惠及城市",
          number: {
            number: [60],
            toFixed: 0,
            textAlign: "left",
            content: "{nt}个",
            style: {
              fontSize: 26,
            },
            formatter,
          },
        },
        {
          title: "就业人数",
          number: {
            number: [5840],
            toFixed: 0,
            textAlign: "left",
            content: "{nt}人",
            style: {
              fontSize: 26,
            },
            formatter,
          },
        },
        {
          title: "培训就业率",
          number: {
            number: [86.84],
            toFixed: 2,
            textAlign: "left",
            content: "{nt}%",
            style: {
              fontSize: 26,
            },
          },
        },
      ],
      ranking: {
        data: [
          {
            // 名字需要与 “common/map/fujian.js” 地图数据文件里面定义的一一对应，不能是 “福州” 或者 “闽” 之类的缩写
            name: "北京",
            value: 210,
          },
          {
            name: "河北",
            value: 6,
          },
          {
            name: "海南",
            value: 1,
          },
          {
            name: "福建",
            value: 1,
          },
          {
            name: "广东",
            value: 1,
          },
          {
            name: "湖北",
            value: 5,
          },
          {
            name: "湖南",
            value: 1,
          },
          {
            name: "吉林",
            value: 1,
          },
          {
            name: "江苏",
            value: 4,
          },
          {
            name: "江西",
            value: 1,
          },
          {
            name: "辽宁",
            value: 1,
          },
          {
            name: "内蒙古",
            value: 1,
          },
          {
            name: "山东",
            value: 4,
          },
          {
            name: "山西",
            value: 1,
          },
          {
            name: "陕西",
            value: 1,
          },
          {
            name: "四川",
            value: 3,
          },
          {
            name: "云南",
            value: 1,
          },
          {
            name: "浙江",
            value: 11,
          },
          {
            name: "上海",
            value: 2,
          },
          {
            name: "天津",
            value: 15,
          },
          {
            name: "重庆",
            value: 1,
          },
        ],
        data1: [
          {
            name: "海淀区",
            value: 55,
          },
          {
            name: "朝阳区",
            value: 120,
          },
          {
            name: "东城区",
            value: 28,
          },
          {
            name: "西城区",
            value: 14,
          },
          {
            name: "丰台区",
            value: 18,
          },
          {
            name: "石景山区",
            value: 10,
          },
          {
            name: "门头沟区",
            value: 35,
          },
          {
            name: "房山区",
            value: 27,
          },
          {
            name: "通州区",
            value: 46,
          },
          {
            name: "顺义区",
            value: 30,
          },
          {
            name: "昌平区",
            value: 38,
          },
          {
            name: "大兴区",
            value: 15,
          },
          {
            name: "怀柔区",
            value: 55,
          },
          {
            name: "平谷区",
            value: 23,
          },
          {
            name: "密云区",
            value: 19,
          },
          {
            name: "延庆区",
            value: 20,
          },
        ],
        carousel: "single",
        unit: "家",
      },
      water: {
        data: [24, 45],
        shape: "roundRect",
        formatter: "{value}%",
        waveNum: 3,
      },
      // 通过率和达标率的组件复用数据
      rate: [
        {
          id: "centerRate1",
          tips: 60,
          colorData: {
            textStyle: "#3fc0fb",
            series: {
              color: ["#00bcd44a", "transparent"],
              dataColor: {
                normal: "#03a9f4",
                shadowColor: "#97e2f5",
              },
            },
          },
        },
        {
          id: "centerRate2",
          tips: 40,
          colorData: {
            textStyle: "#67e0e3",
            series: {
              color: ["#faf3a378", "transparent"],
              dataColor: {
                normal: "#ff9800",
                shadowColor: "#fcebad",
              },
            },
          },
        },
      ],
    }
  },
  methods: {
    format(number) {
      // console.log(number, "number")
      const numbers = number
        .toString()
        .split("")
        .reverse()
      const segs = []

      while (numbers.length) segs.push(numbers.splice(0, 3).join(""))

      return segs
        .join(",")
        .split("")
        .reverse()
        .join("")
    },
  },
  components: {
    // CenterChart
  },
}
</script>

<style lang="scss" scoped>
#center {
  display: flex;
  flex-direction: column;
  .up {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    .item {
      border-radius: 6px;
      padding-top: 8px;
      margin-top: 8px;
      width: 32%;
      height: 70px;
      .dv-dig-flop {
        width: 150px;
        height: 30px;
      }
    }
  }
  .down {
    padding: 6px 4px;
    padding-bottom: 0;
    width: 100%;
    display: flex;
    height: 255px;
    justify-content: space-between;
    .bg-color-black {
      border-radius: 5px;
    }
    .ranking {
      padding: 10px;
      margin-top: 5px;
      width: 100%;
      .dv-scr-rank-board {
        height: 230px;
      }
    }
    .percent {
      width: 40%;
      display: flex;
      flex-wrap: wrap;
      .item {
        width: 50%;
        height: 120px;
        span {
          margin-top: 8px;
          font-size: 14px;
          display: flex;
          justify-content: center;
        }
      }
      .water {
        width: 100%;
        .dv-wa-le-po {
          height: 120px;
        }
      }
    }
  }
}
</style>
